export const Ec2 = {
    region: 'api/aws/lookups/1.0/aws-regions',
    awsSector: 'api/static/lookups/v2/1.0/internal/aws-sectors',
    department: (sector) => `api/static/lookups/v2/1.0/internal/aws-sectors/${sector}`,
    applicationRegion: '/api/static/lookups/v2/1.0/aws-application-regions',
    awsLandingZone: '/api/static/lookups/v2/1.0/aws-landing-zone',
    awsAccounts: '/api/aws/lookups/1.0/aws-accounts',
    vpcID: (payload) => `/api/aws/lookups/1.0/aws-vpcs/${payload?.accountId}`,
    subnetID: (payload) => `api/aws/lookups/1.0/aws-subnets/accountid/${payload?.awsAccount}/vpcid/${payload?.vpcId}`,
    securityGroup: (payload) => `api/aws/lookups/1.0/security-groups/region/${payload?.region}/account/${payload?.awsAccount}/vpc/${payload?.vpcId}`,
    awsDataDisk: (payload) => `api/aws/lookups/1.0/aws-managed-disks/environment/${payload?.environment}`,
    ec2InstanceType: (accountId, region) => `api/aws/lookups/1.0/aws-instance-types/accountId/${accountId}/region/${region}`,
    ec2InstanceTypeV2: (region, availabilityZone) => `api/aws/lookups/1.0/aws-instance-types/region/${region}?availabilityZone=${availabilityZone}`,
    availabilityZones: (payload) => `api/aws/lookups/1.0/aws-availability-zones/${payload?.region}`,
    codeSearchUrl: 'api/project/integration/order/appsec/code-search',
    codeSearch: (appCIName) => `api/project/integration/order/appsec/code-search?appCIName=${encodeURIComponent(appCIName)}`,
    securityGroups: 'api/project/integration/order/appsec/security-groups',
    customBuilds: 'api/static/lookups/aws/1.0/custom-build-types',
};
export default Ec2;
